import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  issueId: string;
};

export const adminGetIssueStatements = createQueryFn(
  QueryNameSpace.adminGetIssueStatements,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const res = await DigiobcanApi.adminGetIssueStatements(params.issueId);
    return res.statements;
  },
);
